import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
// components
import { MotionContainer, varBounceIn, varBounceInUp } from '../components/animate';
import Page from '../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <RootStyle title="For Verification | Minimal-UI">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceInUp}>
              <Typography variant="h3" paragraph>
                Please wait for your account to be verified
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              We are Still processing your account. Thank you for your Patience
            </Typography>

            <motion.div variants={varBounceInUp}>
              <Box
                component="img"
                src="/static/illustrations/girl_waiting.gif"
                sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
              />
            </motion.div>

            {/* <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button> */}
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
